export default {
  pageTitle: '选考设置',
  positionSettings: '职位设置',
  candidateSettings: '候选人设置',
  settings: '设置',

  // 选考流程
  selectionProcess: '选考流程',
  selectionProcessDescription: '根据招聘需求，可设置不同的选考流程。创建职位时可选择适用的选考流程。',

  // 面试评价轴
  interviewEvaluation: '面试评价轴',
  interviewEvaluationDescription: '设置面试评价模板的维度及权重，方便面试官更全面地评价候选人，适用于面试模板和 AI 评分。',

  // 应聘渠道
  applicationSource: '应聘渠道',
  applicationSourceDescription: '可添加不同的申请渠道，用来标记候选人的应聘渠道',
};
